import { useContext } from 'react';

import type { CustomizationState } from './customizationState';
import { LatestCustomizationStateContext } from './TemplateCustomizationProvider';

// The getter reads the ref the Provider advances inside dispatch, so it returns the post-dispatch
// state a render snapshot cannot. This holds only while customizationReducer stays pure.
export function useGetLatestCustomizationState(): () => CustomizationState {
  const getLatestState = useContext(LatestCustomizationStateContext);

  if (!getLatestState) {
    throw new Error(
      'useGetLatestCustomizationState must be used within TemplateCustomizationProvider'
    );
  }

  return getLatestState;
}
